// Types
import type { TAnchorProps, TAnchorSize } from './Anchor.type';

export const ANCHOR_SIZES: TAnchorSize[] = [ 'sm', 'md', 'lg' ];
export const ANCHOR_SIZE:  { [key in TAnchorSize ]: key } = {
  sm: 'sm',
  md: 'md',
  lg: 'lg'
}

export const ANCHOR_DEFAULT_PROPS: TAnchorProps = {
  size: ANCHOR_SIZE.md,
}
